import { createReducer, on } from '@ngrx/store';
import { initialAuthState } from '../consts/auth.constants';
import { AuthActions, AuthApiActions } from './auth.actions';

export const authReducer = createReducer(
  initialAuthState,

  on(AuthActions.login, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthApiActions.loginSuccess, (state, { user }) => ({
    ...state,
    user,
    loading: false,
    error: null,
  })),

  on(AuthApiActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AuthActions.logout, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthApiActions.logoutSuccess, () => ({
    ...initialAuthState,
  })),

  on(AuthApiActions.logoutFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(AuthActions.signup, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(AuthApiActions.signupSuccess, (state, { user }) => ({
    ...state,
    user,
    loading: false,
  })),

  on(AuthApiActions.signupFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);
